import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUpdateProfileMutation } from '../../redux/api/userApi';
import { useSelector } from 'react-redux';
import toast from "react-hot-toast";
import UserLayout from '../layout/UserLayout';

const UpdateProfile = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");


    const navigate = useNavigate();

    const [UpdateProfile, { isLoading, error, isSuccess }] = useUpdateProfileMutation();

    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        if (user) {
            setName(user?.name);
            setEmail(user?.email);
        }
        if (error) {
            toast.error(error?.data?.message);
        }
        if (isSuccess) {
            toast.success("User Updated");
            navigate("/me/profile");
        }
    }, [user, error, isSuccess, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();

        const userData = {
            name,
            email,

        };

        UpdateProfile(userData);
    };

    return (
        <UserLayout>
            <div className="row wrapper mt-0 pt-0">
                <div className="col-12 col-lg-8">
                    <form
                        className="product-card shadow-sm rounded-4 bg-body mb-5" 
                        
                        onSubmit={submitHandler}
                    >
                        <h2 className="mb-4 fw-bold text-gradient">Update Profile</h2>

                        <div className="mb-3">
                            <label htmlFor="name_field" className="form-label" style={{ color: "#e04f6ecd" }}> Name </label>
                            <input
                                type="text"
                                id="name_field"
                                className="form-control"
                                name="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="email_field" className="form-label" style={{ color: "#e04f6ecd" }}> Email </label>
                            <input
                                type="email"
                                id="email_field"
                                className="form-control"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <button type="submit" className="btn w-100 py-2 fw-semibold View-btn" disabled={isLoading}>
                            {isLoading ? "Updating...." : "Update"}
                        </button>
                    </form>
                </div>
            </div>
        </UserLayout>
    )
}

export default UpdateProfile;
